import styled from 'styled-components';

export const FormComposicao = styled.section`
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.25rem;
`;
